import { useLocation } from 'react-router-dom'

import { Tabs as F0Tabs } from '@factorialco/f0-react/dist/experimental'

import { useNodeTabs } from './useNodeTabs'

export function NodeTabs() {
  const location = useLocation()
  const tabs = useNodeTabs()

  return <F0Tabs tabs={tabs} activeTabId={location.pathname} />
}
